import axios from 'axios'
// import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
import { getItem, getItemToken } from '../../Utils/localStorageUtils';
// import { toast } from 'react-toastify';

const headerIndexAction = () => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Header-index`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: "web",
            Login_user_id: parseInt(getItem('id'), 10) || null,
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        });

        const ListRes = response?.data;
        const accessToken = localStorage.getItem("access_token");
        let siteThemeSetting = null;

        if (accessToken) {
            try {
                const themeResponse = await axios.get(
                    `${process.env.REACT_APP_Baseurl}/admin/Site-ThemeSetting/index`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${accessToken}`,
                            Accept: "application/json",
                            "Access-Control-Allow-Origin": "*",
                        }
                    }
                );
                siteThemeSetting = themeResponse?.data?.Site_theme_setting?.[0] || null;
            } catch (themeError) {
                console.warn("Failed to fetch advertiser site theme settings:", themeError);
            }
        }

        const mergedResponse = {
            ...ListRes,
            siteThemeSetting,
        };

        dispatch({ type: "GET_HEADERINDEX_ACTION", payload: mergedResponse });
    }
    catch (error) {
        dispatch({ type: "GET_HEADERINDEX_ACTION_FAILED", payload: error });
    };
}

export { headerIndexAction }
